(function () {
  var path = window.location.pathname.replace(/\/+$/, '') || '/';
  var is404 = Boolean(window.__SABUNAL_SHOPIFY__ && window.__SABUNAL_SHOPIFY__.is404);
  var isPublicCollectionPath = [
    '/collections/all',
    '/collections/dogal-yaglar',
    '/collections/sabunlar',
    '/collections/serumlar-tonikler-ve-aktifler',
    '/collections/bolgesel-bakim'
  ].indexOf(path) !== -1;

  var collectionRedirect = ({
    '/collections/all': '/magaza',
    '/collections/dogal-yaglar': '/kategori/Do%C4%9Fal%20Ya%C4%9Flar',
    '/collections/sabunlar': '/kategori/Sabunlar',
    '/collections/serumlar-tonikler-ve-aktifler': '/kategori/Serumlar%2C%20Tonikler%20ve%20Aktifler',
    '/collections/bolgesel-bakim': '/kategori/B%C3%B6lgesel%20Bak%C4%B1m'
  })[path];
  if (collectionRedirect) {
    window.location.replace(collectionRedirect);
    return;
  }

  if (is404) {
    var initialTitles = {
      '/': 'Sabunal | Soğuk Proses Sabunlar ve Bitkisel Bakım',
      '/magaza': 'Doğal Sabun ve Bitkisel Bakım Ürünleri | Sabunal',
      '/urun-arama': 'Ürün ve İçerik Arama | Sabunal',
      '/bakim-rehberi': 'Bakım Güvenlik Rehberi | Güvenli Ürün Seçimi | Sabunal',
      '/icerikler': 'Ürün Bilgileri | İçerik, Hammadde ve Üretim | Sabunal',
      '/cildine-gore': 'Cilt Tipine Göre Bakım | Sabunal',
      '/sabunal-dunyasi': 'Sabunal Dünyası | Doğal Bakımın Hikâyesi',
      '/baglanti-merkezi': 'Sabunal Bağlantı Merkezi | Tüm Platformlar',
      '/yasal-destek': 'Yasal Destek ve Bilgilendirme | Sabunal',
      '/toptan': 'Toptan Doğal Bakım Ürünleri | Sabunal',
      '/sepet': 'Alışveriş Sepeti | Sabunal',
      '/cart': 'Alışveriş Sepeti | Sabunal',
      '/hesabim': 'Sabunal Üyelik ve Hesabım | Sabunal'
    };
    var initialTitle = initialTitles[path]
      || (path.indexOf('/kategori/') === 0 ? 'Doğal Bakım Kategorileri | Sabunal' : '')
      || (path.indexOf('/icerikler/') === 0 ? 'Doğal Bakım İçerikleri | Sabunal' : '')
      || 'Sabunal | Doğal Bakım ve Ürünler';
    var titleElement = document.querySelector('title');

    if (titleElement && (document.title === '404 Bulunamadı' || document.title === '')) {
      document.title = initialTitle;
    }

    var isKnownSpaPath = isPublicCollectionPath || path === '/'
      || path === '/magaza'
      || path === '/urun-arama'
      || path === '/bakim-rehberi'
      || path.indexOf('/bakim-rehberi/') === 0
      || path === '/cildine-gore'
      || path.indexOf('/cildine-gore/') === 0
      || path === '/icerikler'
      || path.indexOf('/icerikler/') === 0
      || path.indexOf('/kategori/') === 0
      || path === '/sabunal-dunyasi'
      || path.indexOf('/sabunal-dunyasi/') === 0
      || path === '/baglanti-merkezi'
      || path === '/yasal-destek'
      || path === '/toptan'
      || path === '/sepet'
      || path === '/cart'
      || path === '/hesabim'
      || path.indexOf('/urunler/') === 0;

    if (isKnownSpaPath) {
      var canonicalUrl = 'https://sabunal.net' + path;
      var canonicalLink = document.querySelector('link[rel="canonical"]');
      var ogUrl = document.querySelector('meta[property="og:url"]');
      var robots = document.querySelector('meta[name="robots"]');
      var initialRobots = path === '/urun-arama' ? 'noindex,follow' : 'index,follow';
      if (canonicalLink) canonicalLink.setAttribute('href', canonicalUrl);
      if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);
      if (robots) robots.setAttribute('content', initialRobots);
    }
  }

  function go(target) {
    window.location.replace(target);
  }

  var legacyProductMatch = path.match(/^\/(?:urun|urunler)\/([^/]+)$/);
  if (legacyProductMatch) {
    var productHandle = decodeURIComponent(legacyProductMatch[1]);
    var productAliases = {
      'defne-sabunu': 'defenza-defne-sabunu',
      'limon-sabunu': 'citraglow-limon-sabunu'
    };
    go('/products/' + encodeURIComponent(productAliases[productHandle] || productHandle));
    return;
  }

  // Native Shopify collection routes stay on their server-rendered 200 URLs.
  // Legacy /magaza and /kategori/* paths are handled by Shopify URL redirects.

  if (path === '/search') {
    go('/urun-arama');
    return;
  }

  if (path === '/icerikler/cilt-tipini-tani') {
    window.history.replaceState({}, '', '/bakim-rehberi/cilt-tipini-tanima');
    go('/bakim-rehberi/cilt-tipini-tanima');
    return;
  }

  if (path === '/icerikler/rehberler' || path.indexOf('/icerikler/rehberler/') === 0) {
    var legacyGuideSuffix = path.slice('/icerikler/rehberler'.length);
    go('/bakim-rehberi/dogal-bakim-bilgileri' + legacyGuideSuffix);
    return;
  }

  if (path === '/account' || path === '/account/login' || path === '/account/register') {
    go('/hesabim');
    return;
  }

  if (is404) {
    var decodedPath = decodeURIComponent(path);
    var productRoute = decodedPath.indexOf('/products/') === 0;
    var knownCategory = [
      '/kategori/Doğal Yağlar',
      '/kategori/Sabunlar',
      '/kategori/Serumlar, Tonikler ve Aktifler',
      '/kategori/Bölgesel Bakım'
    ].indexOf(decodedPath) !== -1;
    var knownRoute = isPublicCollectionPath || path === '/'
      || path === '/magaza'
      || path === '/urun-arama'
      || path === '/bakim-rehberi'
      || path.indexOf('/bakim-rehberi/') === 0
      || path === '/cildine-gore'
      || path.indexOf('/cildine-gore/') === 0
      || path === '/icerikler'
      || path.indexOf('/icerikler/') === 0
      || path === '/sabunal-dunyasi'
      || path.indexOf('/sabunal-dunyasi/') === 0
      || path === '/baglanti-merkezi'
      || path === '/yasal-destek'
      || path === '/toptan'
      || path === '/sepet'
      || path === '/cart'
      || path === '/hesabim'
      || path.indexOf('/urunler/') === 0;

    if (!productRoute && !knownCategory && !knownRoute) {
      window.__SABUNAL_SKIP_APP__ = true;
      document.getElementById('root').innerHTML = '<main class="section"><div class="container"><span class="eyebrow">404</span><h1>Bu sayfayı bulamadık.</h1><p>Aradığın içerik taşınmış, kaldırılmış veya artık mevcut olmayabilir.</p><a class="button button-primary" href="/">Ana sayfaya dön</a></div></main>';
    }
  }
})();
